import React, { useState } from 'react';
import axiosAuth from '../../api/axiosInstance';
import PasswordInput from '../shared/PasswordInput';
import AuthAlert from '../shared/AuthAlert';

const UserSettings = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');
    setIsError(false);
    try {
      const res = await axiosAuth.post('/auth/user-change-password', { currentPassword, newPassword });
      setMessage(res.data.msg || 'Password updated successfully.');
      setCurrentPassword('');
      setNewPassword('');
    } catch (err) {
      setIsError(true);
      setMessage(err?.response?.data?.msg || 'Failed to update password.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="outlet-content">
      <h2>Change Password</h2>
      <form onSubmit={handleSubmit} style={{ maxWidth: '400px' }}>
        <PasswordInput
          name="currentPassword"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          placeholder="Current password"
        />
        <PasswordInput
          name="newPassword"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="New password"
          minLength={8}
        />
        <button type="submit" className="btn btn-warning mt-3" disabled={isSubmitting}>
          {isSubmitting ? 'Updating...' : 'Update password'}
        </button>
        <AuthAlert message={message} variant={isError ? 'danger' : 'success'} />
      </form>
    </div>
  );
};

export default UserSettings;
